import {autoEffect, store} from '@risingstack/react-easy-state';

import {parseAnswersToObject} from 'Frontend/utils/helpers';
import {CREATED} from 'Server/utils/httpCodes';

let interview = null;

if (process.browser) {
    interview = JSON.parse(sessionStorage.getItem('interviewProcess'));
}

if (interview === null) {
    interview = {
        answers: [],
        maxSteps: 0
    };
}

interview.tree = {
    evaluate() {
        return {key: 'nope'};
    }
};

const InterviewStore = store({
    ...interview,
    get current() {
        const question = this.tree.evaluate(this.answers);

        return question;
    },
    get interviewData() {
        return parseAnswersToObject(this.answers);
    },
    async loadTree() {
        this.tree = (await import(
            /* webpackChunkName: "InterviewTree" */
            'Frontend/configs/InterviewTree'
        )).InterviewTree;
    },
    async sendForm() {
        const query = {
            ...this.interviewData,
            searchRangeCenter: this.interviewData.searchRangeCenter.geo
        };

        const response = await fetch('/api/leads', {
            body: JSON.stringify(query),
            method: 'POST'
        });

        if (response.status === CREATED) {
            const [lead] = await response.json();

            return lead.id;
        }

        return null;
    }
});

autoEffect(() => (process.browser
    ? sessionStorage.setItem(
        'interviewProcess',
        JSON.stringify({
            answers: InterviewStore.answers,
            maxSteps: InterviewStore.maxSteps
        })
    )
    : null
));

InterviewStore.loadTree();

export default InterviewStore;